import React, { useState } from 'react';
import UpgradeModal from './UpgradeModal';

const TIER_LABELS = {
  trial: 'Trial', starter: 'Starter', basic: 'Basic',
  plus: 'Plus', pro: 'Pro', premium: 'Premium', free: 'Free',
};

function PlanBar({ quota, gido, openUpgrade, onRefreshQuota }) {
  const [showUpgrade, setShowUpgrade] = useState(!!openUpgrade);
  const tier = quota?.tier || 'free';

  return (
    <div className="plan-bar">
      <div className="plan-info">
        <span className="plan-label">Current plan</span>
        <span className="plan-tier">{TIER_LABELS[tier] || tier}</span>
      </div>
      <button className="upgrade-link" onClick={() => setShowUpgrade(true)}>
        Manage Plan →
      </button>
      {showUpgrade && <UpgradeModal gido={gido} quota={quota} onClose={() => setShowUpgrade(false)} onRefreshQuota={onRefreshQuota} />}
    </div>
  );
}

export default PlanBar;